import Parameters from "../../components/budget/Parameters/Parameters";
import FormTitle from "../../components/helpers/FormTitle";
import { Box, Tab, Tabs } from "@mui/material";
import AppRights from "../../services/AppRights";
import { useState } from "react";
import ListBudget from "../../components/budget/Parameters/ListBudget";
import { _ROLES_BACK } from "../../utils/constants";

const BudgetParameters = () => {
  const [tab, setTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <Box
        width={"100%"}
        p={2}
        sx={{
          backgroundColor: "white",
        }}
      >
        <AppRights roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]} />
        <FormTitle title="Budget parameters" />
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label="Parameters" />
          <Tab label="List" />
        </Tabs>
        {tab === 0 && <Parameters />}
        {tab === 1 && <ListBudget />}
      </Box>
    </>
  );
};

export default BudgetParameters;
